<!-- Add a container wrapper
<div class="page-container">
  <app-header></app-header>
  <div class="content">
    <div *ngIf="privacyContent" [innerHTML]="privacyContent" class="p-3"></div>
  </div>
  <app-footer></app-footer>
</div> -->

<div class="page-container">
  <app-header></app-header>
  <div class="content">
    <img src="../../assets/images/Frame 20.jpg" alt="About Us" class="aboutus">
    <!-- <div *ngIf="privacyContent" [innerHTML]="privacyContent" class="aboutus-container"></div> -->
    <div class="container py-2">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="card shadow-lg rounded">

            <div class="policy-card">
              <h2>Privacy Policy</h2>

              <p class=" text-start mb-4">Effective Date:
                10-02-2025</p>
              <p class=" text-start mb-4">Website: <a href="mailto:fuprop.com" style="color: #004aad; text-decoration: none;">www.fuprop.com</a>
              </p>
              <h3>Overview</h3>
              <p>
                fuprop.com (“FuProp”, “we”, “our”, or “us”) is committed to protecting the privacy and security of
                personal and property-related data shared on our platform. This Privacy Policy outlines how we collect,
                use, store, disclose, and protect your personal and transactional information.
              </p>
              <p>
                By accessing or using our website, mobile application, or related services (collectively, the “Platform"),
                you acknowledge that you have read, understood, and agree to the terms of this Privacy Policy.
              </p>

              <h3>Scope of This Policy</h3>
              <p>
                This Privacy Policy applies to all users, including property owners, tenants, buyers, sellers, agents, and
                visitors who use or interact with the Platform. It governs the data you provide voluntarily and data
                collected automatically.
              </p>

              <h3>Information We Collect</h3>
              <h4>A. Personally Identifiable Information (PII)</h4>
              <div class="alpha-list">
                <p>a. Name</p>
                <p>b. Email address</p>
                <p>c. Phone number</p>
                <p>d. Residential or business address</p>
              </div>

              <h4>B. Property and Listing Information</h4>
              <div class="alpha-list">
                <p>a. Property address, type, and specifications</p>
                <p>b. Pricing, amenities, photos, and availability</p>
              </div>

              <h4>C. Transaction and Communication Data</h4>
              <div class="alpha-list">
                <p>a. Chat messages within the Platform</p>
              </div>

              <h4>D. Technical & Usage Data</h4>
              <div class="alpha-list">
                <p>a. IP address</p>
                <p>b. Browser type and version</p>
                <p>c. Device identifiers</p>
                <p>d. Cookies and browsing behavior</p>
              </div>

              <h3>Purpose of Data Collection</h3>
              <ul>
                <li>To facilitate listing, promotion, and discovery of properties</li>
                <li>To connect buyers, sellers, landlords, and tenants</li>
                <li>To verify listings and enhance credibility</li>
                <li>To ensure compliance with applicable laws and Platform policies</li>
                <li>To personalize user experience and improve site functionality</li>
                <li>To detect, prevent, and investigate security breaches or fraud</li>
              </ul>

              <h3>Legal Basis for Processing</h3>
              <ul>
                <li>With your explicit consent</li>
                <li>To comply with legal obligations</li>
                <li>Based on our legitimate business interests, including fraud prevention and customer support</li>
              </ul>

              <h3>Data Sharing and Disclosure</h3>
              <ul>
                <li>With other users, in connection with a transaction (e.g., property listing details, contact info)</li>
                <li>With service providers, under strict data protection agreements (e.g., hosting, verification, analytics)</li>
                <li>With law enforcement or regulators, if required by applicable law or valid legal process</li>
                <li>During business transfers, such as mergers or acquisitions (with prior notice, where possible)</li>
              </ul>

              <h3>Data Retention</h3>
              <p>
                We retain personal and listing data for as long as necessary to fulfill the purposes outlined in this policy
                or to comply with legal obligations. Users may request deletion of their data, subject to certain limitations
                (e.g., legal or fraud-related retention requirements).
              </p>

              <h3>Data Security</h3>
              <ul>
                <li>End-to-end encryption where applicable</li>
                <li>Regular security audits and monitoring</li>
                <li>Secure server infrastructure</li>
              </ul>
              <p>
                However, no platform can guarantee 100% security. Users are encouraged to use strong passwords and
                report suspicious activity.
              </p>

              <h3>Cookies and Tracking Technologies</h3>
              <p>We use cookies and similar technologies to:</p>
              <ul>
                <li>Enhance user experience</li>
                <li>Track usage patterns</li>
                <li>Enable secure login</li>
                <li>Provide personalized content and ads</li>
              </ul>
              <p>You may control cookie preferences through your browser settings.</p>

              <h3>Your Rights</h3>
              <p>Subject to applicable law, you may:</p>
              <ul>
                <li>Access and correct your personal data</li>
                <li>Request deletion or deactivation of your account</li>
                <li>Object to or restrict certain data processing activities</li>
                <li>Withdraw consent where previously granted</li>
              </ul>
              <p>Requests can be sent to support@fuprop.com</p>

              <h3>Children's Privacy</h3>
              <p>
                The Platform is not intended for individuals under the age of 18. We do not knowingly collect personal
                information from minors.
              </p>

              <h3>Updates to This Policy</h3>
              <p>
                We may revise this Privacy Policy periodically. Changes will be posted on this page, and significant changes
                will be communicated via email or notification. Continued use of the Platform after such updates constitutes
                acceptance of the new terms.
              </p>

              <h3>Contact Information</h3>
              <p>fuprop.com</p>
              <p>Email:<a href="mailto:fuprop.com" style="color: #004aad; text-decoration: none;">support@fuprop.com</a>
              </p>
              <p>Phone: +91 7838656543</p>
              <p>Address: ANS Greens, Unit-103, Plot 478, Krishna Colony, Gurugram, Haryana, India – 122001</p>
            </div>


          </div></div></div>




    </div>
  </div>

  <app-footer></app-footer>
</div>
